import { Direction } from '@angular/cdk/bidi';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'mot-slide-toggle',
    templateUrl: './mot-slide-toggle.component.html',
    styleUrls: ['./mot-slide-toggle.component.scss'],
    standalone: false
})
export class MotSlideToggleComponent {
  @Output() onToggleChange = new EventEmitter<boolean>();

  @Input() value: boolean;
  @Input() disabled: boolean;
  @Input() label: string;
  @Input() class: string | string[] | Set<string> | { [klass: string]: any };
  @Input() dir: Direction | "auto" = 'rtl';
}
